/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type ListPlatformExternalCredentialsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

/**
 * Only return credentials for this provider.
 */
export const Provider = {
  AwsIam: "aws_iam",
  GcpIam: "gcp_iam",
} as const;
/**
 * Only return credentials for this provider.
 */
export type Provider = ClosedEnum<typeof Provider>;

export type ListPlatformExternalCredentialsRequest = {
  /**
   * Only return credentials for this provider.
   */
  provider?: Provider | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListPlatformExternalCredentialsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListPlatformExternalCredentialsSecurity$outboundSchema:
  z.ZodMiniType<
    ListPlatformExternalCredentialsSecurity$Outbound,
    ListPlatformExternalCredentialsSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listPlatformExternalCredentialsSecurityToJSON(
  listPlatformExternalCredentialsSecurity:
    ListPlatformExternalCredentialsSecurity,
): string {
  return JSON.stringify(
    ListPlatformExternalCredentialsSecurity$outboundSchema.parse(
      listPlatformExternalCredentialsSecurity,
    ),
  );
}

/** @internal */
export const Provider$outboundSchema: z.ZodMiniEnum<typeof Provider> = z.enum(
  Provider,
);

/** @internal */
export type ListPlatformExternalCredentialsRequest$Outbound = {
  provider?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListPlatformExternalCredentialsRequest$outboundSchema:
  z.ZodMiniType<
    ListPlatformExternalCredentialsRequest$Outbound,
    ListPlatformExternalCredentialsRequest
  > = z.pipe(
    z.object({
      provider: z.optional(Provider$outboundSchema),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
      });
    }),
  );

export function listPlatformExternalCredentialsRequestToJSON(
  listPlatformExternalCredentialsRequest:
    ListPlatformExternalCredentialsRequest,
): string {
  return JSON.stringify(
    ListPlatformExternalCredentialsRequest$outboundSchema.parse(
      listPlatformExternalCredentialsRequest,
    ),
  );
}
